import { c as _c } from "react/compiler-runtime";
import { Breadcrumb as UIBreadcrumb } from '@onefootprint/ui';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import useEntitiesQueryParams from '@/components/entities/hooks/use-entities-query-params';
import { useEntityContext } from '@/entity/hooks/use-entity-context';
const Breadcrumb = () => {
  const $ = _c(23);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "breadcrumb"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t0);
  const {
    kind,
    listPath
  } = useEntityContext();
  const {
    searchParams
  } = useEntitiesQueryParams();
  let T0;
  let params;
  let t1;
  let title;
  if ($[1] !== kind || $[2] !== searchParams || $[3] !== t) {
    const label = kind === "person" ? t(_temp) : t(_temp2);
    let t2;
    if ($[8] !== kind || $[9] !== t) {
      t2 = kind === "person" ? t(_temp3) : t(_temp4);
      $[8] = kind;
      $[9] = t;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    title = t2;
    params = searchParams ? `?${searchParams}` : "";
    T0 = UIBreadcrumb.List;
    t1 = t(_temp5, {
      kind: label
    });
    $[1] = kind;
    $[2] = searchParams;
    $[3] = t;
    $[4] = T0;
    $[5] = params;
    $[6] = t1;
    $[7] = title;
  } else {
    T0 = $[4];
    params = $[5];
    t1 = $[6];
    title = $[7];
  }
  const t2 = `${listPath}${params}`;
  let t3;
  if ($[11] !== t2 || $[12] !== title) {
    t3 = <UIBreadcrumb.Item href={t2} as={Link}>{title}</UIBreadcrumb.Item>;
    $[11] = t2;
    $[12] = title;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t) {
    t4 = t(_temp6);
    $[14] = t;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== t4) {
    t5 = <UIBreadcrumb.Item>{t4}</UIBreadcrumb.Item>;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== T0 || $[19] !== t1 || $[20] !== t3 || $[21] !== t5) {
    t6 = <T0 aria-label={t1}>{t3}{t5}</T0>;
    $[18] = T0;
    $[19] = t1;
    $[20] = t3;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
};
export default Breadcrumb;
function _temp($) {
  return $.person.label;
}
function _temp2($_0) {
  return $_0.business.label;
}
function _temp3($_1) {
  return $_1.person.title;
}
function _temp4($_2) {
  return $_2.business.title;
}
function _temp5($_3) {
  return $_3.title;
}
function _temp6($_4) {
  return $_4.details;
}